<template>
  <div class="section summary-container">
    <div class="position-relative">
      <loading
        v-model:active="isLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <label class="form-label">Activity For Selected Date Range</label>
        </div>
        <div
          class="date-range-picker date-range-picker-channel position-relative mb-4"
        >
          <loading
            v-model:active="dateRangeLoading1"
            :is-full-page="false"
            loader="dots"
            :opacity="1"
          />
          <VueDatePicker
            v-model="dateRange1"
            range
            multi-calendars
            :min-date="campaignStartDate"
            :max-date="yesterday"
            :enable-time-picker="false"
            ref="datepicker1"
          >
            <template #left-sidebar>
              <div v-for="(val, key) in rangeTypes" :key="key">
                <button
                  type="button"
                  class="btn"
                  :class="{ active: this.rangeType == key }"
                  @click="updateRange1(key)"
                >
                  {{ val }}
                </button>
              </div>
            </template>
          </VueDatePicker>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col mb-md-4" v-for="(item, key) in kpis" :key="key">
          <div class="kpi-container">
            <div class="d-flex mb-2">
              <div>
                <p class="kpi-header mb-0 custom-field">
                  {{ key }}
                </p>
                <p class="kpi-value mb-0">{{ item.val }}</p>
              </div>
              <div v-if="key == 'Frequency'" class="benchmark-container">
                <p class="kpi-header mb-0 custom-field">Benchmark</p>
                <p class="kpi-value mb-0">{{ benchmark }}</p>
              </div>
            </div>
            <p class="kpi-subtitle mb-0">{{ item.subTitle }}</p>
          </div>
        </div>
      </div>
      <label class="form-label">Reach - Previous Month</label>
      <!-- <div class="row row-cols-1 row-cols-md-3"> -->
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col mb-md-4" v-for="(item, key) in pre_kpis" :key="key">
          <div class="kpi-container">
            <div class="d-flex mb-2">
              <div>
                <p class="kpi-header mb-0 custom-field">
                  {{ key }}
                </p>
                <p class="kpi-value mb-0">{{ item.val }}</p>
              </div>
              <!-- <div v-if="key == 'Frequency'" class="benchmark-container">
                <p class="kpi-header mb-0 custom-field">Benchmark</p>
                <p class="kpi-value mb-0">{{ benchmark }}</p>
              </div> -->
            </div>
            <p class="kpi-subtitle mb-0">{{ item.subTitle }}</p>
          </div>
        </div>
      </div>
      <label class="form-label mt-2">All-Time Activity</label>
      <div class="row row-cols-1 row-cols-md-2">
        <!-- <div class="row row-cols-1 row-cols-md-3"> -->
        <div class="col" v-for="(item, key) in all_kpis" :key="key">
          <div class="kpi-container">
            <p class="kpi-header mb-0 custom-field">{{ key }}</p>
            <p class="kpi-value mb-0">{{ item.val }}</p>
            <p class="kpi-subtitle mb-0">{{ item.subTitle }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="position-relative">
      <loading
        v-model:active="isTenantLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <label class="form-label mt-4">Tenant Reach</label>
      <div class="row row-cols-1 row-cols-md-3">
        <div class="col">
          <div class="kpi-container">
            <p class="kpi-header mb-0 custom-field">Tenant Companies Reached</p>
            <p class="kpi-value mb-0">{{ tenantReached }}</p>
            <p class="kpi-subtitle mb-0">
              Number of unique tenant companies that viewed your ad.
            </p>
          </div>
        </div>
        <div class="col">
          <div class="kpi-container">
            <p class="kpi-header mb-0 custom-field">Tenant Companies Reached</p>
            <p class="kpi-value mb-0">{{ tenantReachedPercent }}</p>
            <p class="kpi-subtitle mb-0">
              Percentage of unique tenant companies that viewed your ad.
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="section channel-section position-relative">
    <loading
      v-model:active="isLoading"
      :is-full-page="false"
      loader="dots"
      :opacity="1"
    />
    <div class="d-flex justify-content-between channel-container">
      <div class="d-flex align-items-center">
        <label class="form-label">By Channel</label>
      </div>
      <div
        class="date-range-picker date-range-picker-channel position-relative"
      >
        <loading
          v-model:active="dateRangeLoading"
          :is-full-page="false"
          loader="dots"
          :opacity="1"
        />
        <div>
          <VueDatePicker
            v-model="dateRange"
            range
            multi-calendars
            :min-date="campaignStartDate"
            :max-date="yesterday"
            :enable-time-picker="false"
            ref="datepicker"
          >
            <template #left-sidebar>
              <div v-for="(val, key) in rangeTypes" :key="key">
                <button
                  type="button"
                  class="btn"
                  :class="{ active: this.rangeType == key }"
                  @click="updateRange(key)"
                >
                  {{ val }}
                </button>
              </div>
            </template>
          </VueDatePicker>
        </div>
      </div>
    </div>
    <div class="channel-table mt-4">
      <div class="channel-data-container">
        <div class="row">
          <div class="col">
            <div class="platformInfo platformHeader">&nbsp;</div>
          </div>
          <!-- <div class="col">
            <div class="platformInfo platformHeader custom-field">
              Value
              <VTooltip
                class="form-tooltip"
                :triggers="['click']"
                :autoHide="true"
              >
                <img src="@/assets/question-mark.svg" />

                <template #popper>
                  {{ tooltips.channelSpendTotal }}
                </template>
              </VTooltip>
            </div>
          </div> -->
          <div class="col">
            <div class="platformInfo platformHeader custom-field">
              Views
              <VTooltip
                class="form-tooltip"
                :triggers="['click']"
                :autoHide="true"
              >
                <img src="@/assets/question-mark.svg" />

                <template #popper>
                  {{ tooltips.channelViewsTotal }}
                </template>
              </VTooltip>
            </div>
          </div>
          <div class="col">
            <div class="platformInfo platformHeader custom-field">
              Clicks
              <VTooltip
                class="form-tooltip"
                :triggers="['click']"
                :autoHide="true"
              >
                <img src="@/assets/question-mark.svg" />

                <template #popper>
                  {{ tooltips.channelClicksTotal }}
                </template>
              </VTooltip>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-for="(item, index) in detailChannelData"
          :key="index"
        >
          <div class="col">
            <div
              class="platformInfo platformTitle"
              :class="item.name + '-bubble'"
            >
              <img
                class="platformIcon"
                :src="getImgUrl(item.icon)"
                :alt="item.name"
                v-if="item.name !== 'all'"
              />
              <span>
                {{ item.name == "all" ? "TOTAL" : item.name.toUpperCase() }}
              </span>
            </div>
          </div>
          <div class="col" v-for="(val, key) in item.props" :key="key">
            <div
              class="platformInfo d-flex align-items-center"
              :class="item.name + '-bubble'"
            >
              <span :class="{ 'bold-font': item.name == 'all' }">
                {{ val }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <label class="form-label">Top Websites and Apps Your Ad Appeared On</label>
    <div class="position-relative">
      <loading
        v-model:active="isWebsitesLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <div class="section-data-conatiner">
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-3"
            v-for="($website, index) in websites"
            :key="index"
          >
            <span
              class="website-container w-100"
              :class="{
                'top-border':
                  (isMobile && index < 1) ||
                  (isTablet && index < 2) ||
                  (!isMobile && !isTablet && index < 4),
              }"
            >
              <img :src="getImgUrl($website.logo, false)" />
              <span>{{ $website.name }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section position-relative" v-if="campaignLikes.length > 0">
    <div class="row">
      <label class="col form-label">People Who "Liked" Your Ad</label>
      <div class="col text-end">
        <JsonCSV
          :data="campaignLikesExport"
          :name="campaignData.campaignName + '-Likes.csv'"
          class="export-btn move-up"
        >
          <button class="btn btn-dark wti-btn-black">Export to CSV</button>
        </JsonCSV>
      </div>
    </div>

    <div class="position-relative section-data-conatiner">
      <loading
        v-model:active="isCompaniesLikesLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <div>
        <datatable-component
          v-if="!isCompaniesLikesLoading"
          :keys="likeskeys"
          :columns="likesColumns"
          :data="campaignLikes"
          :options="{
            paging: false,
            searching: false,
            info: false,
            responsive: true,
            scrollY:
              campaignLikes.length > 0
                ? campaignLikes.length * 36 > 400
                  ? 400
                  : campaignLikes.length * 36
                : 40,
          }"
        />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.bold-font
  font-weight: 600
.kpi-container
  border: 1px solid $LightGreyBorder
  border-radius: 20px
  width: 100%
  min-height: 101px
  height: 100%
  .kpi-header
    font-weight: 600
    font-size: 16px
    line-height: 20px
    color: $Main
    padding: 26px 20px 7px
    +laptop
      font-size: 15px
    +mobile
      font-size: 14px
      padding: 14px 14px 12px
  .kpi-value
    font-weight: 600
    font-size: 18px
    line-height: 23px
    padding: 0 20px 6px
    color: $Main
    +laptop
      font-size: 17px
    +mobile
      font-size: 16px
      padding: 0 14px 14px
    span
      font-weight: 600
    .month-avg
      margin-right: 8px
    .contract-value
      color: $Blue
      font-size: 12px
      font-weight: 400
      line-height: 15px
      display: inline-block
  .kpi-subtitle
    padding: 0 20px 19px
    font-size: 9px
    font-weight: 400
    line-height: 11.34px
    text-align: left
    color: #809FB8
  +mobile
    margin-bottom: 10px
    height: 90%
.channel-table
  .title
    border: 1px solid $LightGreyBorder
    border-radius: 10px
    padding: 10px
    color: $LightGrey
    font-size: 0.65rem
  .platformInfo.platformHeader
    font-weight: 600
    font-size: 16px
    line-height: 20px
    text-align: center
    color: $Main
    min-height: 34px
    margin-bottom: 0
    +mobile
      font-size: 14px
  .platformInfo
    border-radius: 10px
    font-weight: 600
    font-size: 14px
    line-height: 18px
    min-height: 44px
    margin-bottom: 9px
    +mobile
      font-size: 12px
    .platformIcon
      height: 20px
      margin: 11px 10px 11px 20px
      +mobile
        margin: 11px 5px 11px 11px
    span
      width: 100%
      text-align: center
  .platformInfo.platformTitle span
    font-size: 12px
    font-weight: 600
    +mobile
      font-size: 10px
  .linkedin-bubble
    color: $Main
    background-color: $LinkedinBg
  .google-bubble
    color: $Main
    background-color: $DisplayBg
  .video-bubble
    color: $Main
    background-color: $YoutubeBg
  .facebook-bubble
    color: $Main
    background-color: $FacebookBg
  .instagram-bubble
    color: $Main
    background-color: $InstagramBg
  .search-bubble
    color: $Main
    background-color: $SearchBg
  .twitter-bubble
    color: $Main
    background-color: $TwitterBg
  .all-bubble
    color: $Main
    background-color: #4759931A
    display: flex
    align-items: center
  .all-bubble.platformTitle span
    padding-left: 20px
    text-align: start
.section-data-conatiner
  min-height: 80px
.website-container
  border-bottom: 1px solid $LightGreyBorder
  display: inline-block
  font-size: 14px
  line-height: 1.3
  padding: 15px 10px
  color: #06152B
  img
    height: 25px
    width: 25px
    margin: 0 19px 0 0
.website-container.top-border
  border-top: 1px solid $LightGreyBorder
.channel-container
  .form-label
    margin-bottom: 0 !important
.date-range-picker-channel
  .dp__main
    width: 220px !important
.benchmark-container
  margin-top: 14px
  margin-right: 20px
  .kpi-header
    color: #3A36DB
    padding: 12px 20px 7px
  .kpi-value
    color: #3A36DB
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import moment from "moment";
import tooltips from "@/utils/tooltips.json";
import DatatableComponent from "@/components/DatatableComponent.vue";
import JsonCSV from "vue-json-csv";

export default {
  name: "AdOverview",
  emits: [
    "updateCampaignData",
    "updateTenantCompaniesData",
    "enablePDFDownload",
    "updateWebsitesData",
    "updateChannelData",
    "updateLikesData",
  ],
  setup(props) {
    var yesterday = moment().subtract(1, "days").toDate();
    var iniProps = {
      // cost: "-",
      views: "-",
      clicks: "-",
    };
    const datepicker = ref(null);
    const datepicker1 = ref(null);

    return {
      campaignData: ref({
        campaignName: null,
        pre: {
          cost: null,
          impressions: null,
          clicks: null,
        },
        all: {
          cost: null,
          impressions: null,
          clicks: null,
        },
      }),
      isLoading: ref(true),
      dateRangeLoading: ref(true),
      dateRangeLoading1: ref(true),
      // isTenantLoading: ref(true),
      tenantReached: ref(null),
      tenantReachedPercent: ref(null),
      benchmark: ref(null),
      isWebsitesLoading: ref(true),
      websites: ref([]),
      tooltips: tooltips.report,
      isMobile: ref(false),
      isTablet: ref(false),
      yesterday: yesterday,
      dateRange: ref([]),
      dateRange1: ref([]),
      rangeType: ref("all"),
      rangeTypes: ref({
        yesterday: "Yesterday",
        last7: "Last 7 Days",
        last30: "Last 30 Days",
        thisMonth: "This Month",
        lastMonth: "Last Month",
        all: "All",
      }),
      startDate: ref(null),
      endDate: ref(null),
      detailChannelData: ref([
        {
          name: "linkedin",
          icon: "linkedin",
          props: JSON.parse(JSON.stringify(iniProps)),
        },
        {
          name: "google",
          icon: "google",
          props: JSON.parse(JSON.stringify(iniProps)),
        },
        {
          name: "facebook",
          icon: "facebook",
          props: JSON.parse(JSON.stringify(iniProps)),
        },
        {
          name: "instagram",
          icon: "instagram",
          props: JSON.parse(JSON.stringify(iniProps)),
        },
        {
          name: "all",
          icon: null,
          props: JSON.parse(JSON.stringify(iniProps)),
        },
      ]),
      datepicker,
      datepicker1,
      campaignLikes: ref([]),
      isCompaniesLikesLoading: ref(true),
      likeskeys: ["Name", "Email", "Job Title", "Company", "Channel"],
      likesColumns: [
        {
          data: "name",
          defaultContent: "-",
          className: "align-middle",
        },
        {
          data: "email",
          defaultContent: "-",
          className: "align-middle",
        },
        {
          data: "jobTitle",
          defaultContent: "-",
          className: "align-middle",
        },
        {
          data: "company",
          defaultContent: "-",
          className: "align-middle",
        },
        {
          data: "channel",
          defaultContent: "-",
          className: "align-middle",
        },
      ],
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: false,
    },
    users: {
      type: Array,
      required: false,
    },
  },
  components: {
    DatatableComponent,
    JsonCSV,
  },
  computed: {
    campaignStartDate() {
      if (this.startDate) {
        return this.startDate;
      } else {
        return moment("2022-10-01").utc().toDate();
      }
    },
    kpis() {
      var data = {
        // Value: {
        //   val: "N/A",
        //   subTitle:
        //     "Amount spent on the campaign, including the Walkthruit fee.",
        // },
        Views: {
          val: "N/A",
          subTitle: "Number of times your ad has been viewed (impressions).",
        },
        Clicks: {
          val: "N/A",
          subTitle:
            "Number of times your ad has been clicked, indicating interest.",
        },
      };
      if (this.campaignData.campaignName) {
        var views = this.campaignData.pre.impressions;
        var clicks = this.campaignData.pre.clicks;
        if (views) {
          data.Views.val = views.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
        if (clicks) {
          data.Clicks.val = clicks.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
      }
      return data;
    },
    pre_kpis() {
      var data = {
        // Value: {
        //   val: "N/A",
        //   subTitle:
        //     "Amount spent on the campaign, including the Walkthruit fee.",
        // },
        "Tenant Reach": {
          val: "N/A",
          subTitle:
            "Number of unique tenant contacts that saw your ad in the prior month.",
        },
        "Broker Reach": {
          val: "N/A",
          subTitle:
            "Number of unique broker contacts that saw your ad in the prior month.",
        },
        // Frequency: {
        //   val: "N/A",
        //   subTitle:
        //     "Average number of times your target audience saw your ad in the prior month.",
        // },
      };
      if (this.campaignData.campaignName) {
        // var cost = this.campaignData.pre.cost;
        var tenantReach = this.campaignData.pre.tenantReach;
        var brokerReach = this.campaignData.pre.brokerReach;
        // var frequency = this.campaignData.pre.frequency;
        // if (cost) {
        // data.Value.val =
        //   "$" +
        //   cost.toLocaleString(undefined, {
        //     minimumFractionDigits: 2,
        //     maximumFractionDigits: 2,
        //   });
        // }
        if (tenantReach) {
          data["Tenant Reach"].val = tenantReach.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
        if (brokerReach) {
          data["Broker Reach"].val = brokerReach.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
        // if (frequency) {
        //   data.Frequency.val = frequency.toLocaleString(undefined, {
        //     maximumFractionDigits: 1,
        //   });
        // }
      }
      return data;
    },
    all_kpis() {
      var data = {
        // Value: {
        //   val: "N/A",
        //   subTitle:
        //     "Amount spent on the campaign, including the Walkthruit fee.",
        // },
        Views: {
          val: "N/A",
          subTitle: "Number of times your ad has been viewed (impressions).",
        },
        Clicks: {
          val: "N/A",
          subTitle:
            "Number of times your ad has been clicked, indicating interest.",
        },
      };
      if (this.campaignData.campaignName) {
        var cost = this.campaignData.all.cost;
        var views = this.campaignData.all.impressions;
        var clicks = this.campaignData.all.clicks;
        if (cost) {
          // data.Value.val =
          //   cost == 0
          //     ? "$" + cost
          //     : "$" +
          //       cost.toLocaleString(undefined, {
          //         minimumFractionDigits: 2,
          //         maximumFractionDigits: 2,
          //       });
        }
        if (views) {
          data.Views.val = views.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
        if (clicks) {
          data.Clicks.val = clicks.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          });
        }
      }
      return data;
    },
    currentUser() {
      var userId = null;
      if (this.$store.state.user?.userId) {
        userId = this.$store.state.user.userId;
      }
      if (this.$store.state.user?.currentUserId) {
        userId = this.$store.state.user.currentUserId;
      }
      return userId;
    },
    allLoaded() {
      var loader =
        !this.isLoading &&
        // !this.isTenantLoading &&
        !this.isWebsitesLoading &&
        !this.isCompaniesLikesLoading;
      return loader;
    },
    campaignLikesExport() {
      var results = [];
      if (this.campaignLikes) {
        this.campaignLikes.forEach((like) => {
          results.push({
            Name: like.name,
            Email: like.email,
            "Job Title": like.jobTitle,
            Company: like.company,
            Channel: like.channel,
          });
        });
      }
      return results;
    },
  },
  methods: {
    getWebsitesReport() {
      this.isWebsitesLoading = true;
      var _this = this;
      var info = {
        campaignId: this.campaignId,
      };
      if (this.token) {
        info.token = this.token;
      }
      api()
        .getWebsitesList(info)
        .then((res) => {
          if (res.data) {
            if (
              this.campaignId == "652d4ce096d5ae0503069180" ||
              this.campaignId == "685c4bdcb856f40bca877fdf"
            ) {
              var mockWebsites = [
                { name: "LinkedIn", logo: "linkedin.png" },
                { name: "Facebook", logo: "facebook.png" },
                { name: "Instagram", logo: "instagram.png" },
              ];
              _this.websites = [...mockWebsites, ...res.data];
            } else {
              _this.websites = res.data;
            }
            _this.$emit("updateWebsitesData", _this.websites);
            setTimeout(() => {
              _this.isWebsitesLoading = false;
            }, 500);
          }
        });
    },
    getKpisData() {
      this.isLoading = true;
      this.dateRangeLoading = true;
      this.dateRangeLoading1 = true;
      var _this = this;
      var info = {
        campaignId: this.campaignId,
      };
      if (this.token) {
        info.token = this.token;
      }
      api()
        .kpisReport(info)
        .then((res) => {
          if (res.data) {
            var start = res.data.startDate
              ? moment(res.data.startDate).utc().format("YYYY-MM-DD HH:mm:ss")
              : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
            var endDate = res.data.endDate
              ? moment(res.data.endDate).utc().format("YYYY-MM-DD HH:mm:ss")
              : _this.yesterday;
            var pre_start = res.data.preStartDate
              ? moment(res.data.preStartDate)
                  .utc()
                  .format("YYYY-MM-DD HH:mm:ss")
              : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
            var pre_endDate = res.data.preEndDate
              ? moment(res.data.preEndDate).utc().format("YYYY-MM-DD HH:mm:ss")
              : _this.yesterday;
            if (
              _this.campaignId == "652d4ce096d5ae0503069180" ||
              _this.campaignId == "685c4bdcb856f40bca877fdf"
            ) {
              _this.dateRange = [
                moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss"),
                moment("2023-02-28").utc().format("YYYY-MM-DD HH:mm:ss"),
              ];
              _this.dateRange1 = [
                moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss"),
                moment("2022-12-31").utc().format("YYYY-MM-DD HH:mm:ss"),
              ];
              var originalData = res.data;
              originalData.pre.cost = 1424.48;
              originalData.pre.impressions = 7577;
              originalData.pre.clicks = 19;
              originalData.pre.tenantReach = 276;
              originalData.pre.brokerReach = 185;
              originalData.pre.frequency = 18.7;
              _this.campaignData = originalData;
            } else {
              _this.dateRange = [start, endDate];
              if (moment(start).utc().isSameOrAfter(moment(endDate).utc())) {
                _this.dateRange = [start, start];
              }
              _this.dateRange1 = [pre_start, pre_endDate];
              if (
                moment(pre_start).utc().isSameOrAfter(moment(pre_endDate).utc())
              ) {
                _this.dateRange1 = [pre_start, pre_start];
              }
              _this.campaignData = res.data;
            }
            _this.benchmark = res.data.pre.benchmark;
            _this.setDetailChannelData(
              _this.campaignData,
              _this.dateRange[0],
              _this.dateRange[1]
            );
            _this.startDate = start;
            _this.endDate = endDate;
            _this.isLoading = false;
            _this.dateRangeLoading = false;
            _this.dateRangeLoading1 = false;
            _this.$emit("updateCampaignData", _this.prepareReportData());
          }
        });
    },
    // getTenantCompaniesData() {
    //   this.isTenantLoading = true;
    //   var _this = this;
    //   var info = {
    //     campaignId: this.campaignId,
    //     total: true,
    //   };
    //   if (this.token) {
    //     info.token = this.token;
    //   }
    //   api()
    //     .getTenantCompaniesData(info)
    //     .then((res) => {
    //       if (res.data) {
    //         _this.tenantReached = res.data?.total ? res.data.total : "N/A";
    //         _this.tenantReachedPercent = res.data?.percentage
    //           ? res.data.percentage.toLocaleString(undefined, {
    //               minimumFractionDigits: 0,
    //               maximumFractionDigits: 0,
    //             }) + "%"
    //           : "N/A";
    //         _this.isTenantLoading = false;
    //         _this.$emit("updateTenantCompaniesData", {
    //           tenantReached: _this.tenantReached,
    //           tenantReachedPercent: _this.tenantReachedPercent,
    //         });
    //       }
    //     });
    // },
    getImgUrl(name, noExtension = true) {
      if (noExtension) {
        return new URL(`../assets/${name}.png`, import.meta.url).href;
      } else {
        return new URL(`../assets/${name}`, import.meta.url).href;
      }
    },
    setDetailChannelData(campaignData, startDate, endDate) {
      this.detailChannelData.forEach((item) => {
        var ele = campaignData[item.name];
        if (ele) {
          // if (ele.cost) {
          // item.props.cost =
          //   "$" +
          //   ele.cost.toLocaleString(undefined, {
          //     minimumFractionDigits: 2,
          //     maximumFractionDigits: 2,
          //   });
          // } else {
          //   item.props.cost = "$0";
          // }
          if (ele.impressions) {
            item.props.views = ele.impressions.toLocaleString(undefined, {
              maximumFractionDigits: 1,
            });
          } else {
            item.props.views = "N/A";
          }

          if (ele.clicks) {
            item.props.clicks = ele.clicks.toLocaleString(undefined, {
              maximumFractionDigits: 1,
            });
          } else {
            item.props.clicks = "N/A";
          }
        }
        return item;
      });
      this.$emit("updateChannelData", {
        ...{ data: this.detailChannelData },
        ...{
          dates:
            moment(startDate).format("MM/DD/YYYY") +
            " - " +
            moment(endDate).format("MM/DD/YYYY"),
        },
      });
    },
    updateDetailChannelData() {
      this.clear();
      var _this = this;
      var startDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
      var end = this.dateRange[1];
      if (!end) end = this.dateRange[0];
      var endDate = moment(end).format("YYYY-MM-DD");
      var info = {
        campaignId: this.campaignId,
        startDate: startDate,
        endDate: endDate,
      };
      if (this.token) {
        info.token = this.token;
      }
      api()
        .detailChannelReport(info)
        .then((res) => {
          if (res.data) {
            _this.setDetailChannelData(res.data, startDate, endDate);
            _this.dateRangeLoading = false;
          }
        });
    },
    updateKpiData() {
      var _this = this;
      this.dateRangeLoading1 = true;
      var startDate = moment(this.dateRange1[0]).format("YYYY-MM-DD");
      var end = this.dateRange1[1];
      if (!end) end = this.dateRange1[0];
      var endDate = moment(end).format("YYYY-MM-DD");
      var info = {
        campaignId: this.campaignId,
        startDate: startDate,
        endDate: endDate,
      };
      if (this.token) {
        info.token = this.token;
      }
      api()
        .getCampaignKpiData(info)
        .then((res) => {
          if (res.data) {
            _this.campaignData.pre.impressions = res.data.impressions;
            _this.campaignData.pre.clicks = res.data.clicks;
            _this.dateRangeLoading1 = false;
            _this.$emit("updateCampaignData", _this.prepareReportData());
          }
        });
    },
    getCampaignLikes() {
      var _this = this;
      var info = {
        campaignId: this.campaignId,
      };
      this.isCompaniesLikesLoading = true;
      api()
        .getCampaignLikes(info)
        .then((res) => {
          if (res.data) {
            _this.campaignLikes = res.data;
            _this.isCompaniesLikesLoading = false;
            _this.$emit("updateLikesData", _this.prepareLikesData());
          }
        });
    },
    async getData() {
      this.getKpisData();
      // this.getTenantCompaniesData();
      this.getWebsitesReport();
      this.getCampaignLikes();
    },
    clear() {
      this.dateRangeLoading = true;
    },
    prepareReportData() {
      var _this = this;
      var result = {
        pre: {
          // cost: {
          //   val: this.pre_kpis.Value.val,
          //   subTitle:
          //     "Amount spent on the campaign, including the Walkthruit fee.",
          // },
          views: {
            val: this.kpis.Views.val,
            subTitle: "Number of times your ad has been viewed (impressions)..",
          },
          clicks: {
            val: this.kpis.Clicks.val,
            subTitle:
              "Number of times your ad has been clicked, indicating interest.",
          },
          tenantReach: {
            val: this.pre_kpis["Tenant Reach"].val,
            subTitle:
              "Number of unique tenant contacts that saw your ad in the prior month.",
          },
          brokerReach: {
            val: this.pre_kpis["Broker Reach"].val,
            subTitle:
              "Number of unique broker contacts that saw your ad in the prior month.",
          },
          // frequency: {
          //   val: this.pre_kpis.Frequency.val,
          //   subTitle:
          //     "Average number of times your target audience saw your ad in the prior month.",
          // },
          // benchmark: this.benchmark,
          kpi_dates:
            moment(_this.dateRange1[0]).format("MM/DD/YYYY") +
            " - " +
            moment(_this.dateRange1[1]).format("MM/DD/YYYY"),
        },
        all: {
          // cost: {
          //   val: this.all_kpis.Value.val,
          //   subTitle:
          //     "Amount spent on the campaign, including the Walkthruit fee.",
          // },
          views: {
            val: this.all_kpis.Views.val,
            subTitle: "Number of times your ad has been viewed (impressions).",
          },
          clicks: {
            val: this.all_kpis.Clicks.val,
            subTitle:
              "Number of times your ad has been clicked, indicating interest.",
          },
        },
      };
      return result;
    },
    updateRange(type) {
      var yesterday = this.yesterday;
      this.rangeType = type;
      this.dateRangeLoading = true;
      switch (type) {
        case "yesterday":
          this.dateRange = [yesterday, yesterday];
          break;
        case "last7":
          this.dateRange = [
            moment(yesterday).subtract(6, "d").toDate(),
            yesterday,
          ];
          break;
        case "last30":
          this.dateRange = [
            moment(yesterday).subtract(29, "d").toDate(),
            yesterday,
          ];
          break;
        case "thisMonth":
          this.dateRange = [
            moment(yesterday).startOf("month").toDate(),
            yesterday,
          ];
          break;
        case "lastMonth":
          this.dateRange = [
            moment(yesterday).subtract(1, "months").startOf("month"),
            moment(yesterday).subtract(1, "months").endOf("month"),
          ];
          break;
        case "all":
          var start = this.startDate
            ? moment(this.startDate).format("YYYY-MM-DD HH:mm:ss")
            : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
          var endDate = this.endDate
            ? moment(this.endDate).format("YYYY-MM-DD HH:mm:ss")
            : yesterday;
          this.dateRange = [start, endDate];
          break;
      }
      if (this.datepicker1) {
        this.datepicker1.closeMenu();
      }
    },
    updateRange1(type) {
      var yesterday = this.yesterday;
      this.rangeType = type;
      this.dateRangeLoading1 = true;
      switch (type) {
        case "yesterday":
          this.dateRange1 = [yesterday, yesterday];
          break;
        case "last7":
          this.dateRange1 = [
            moment(yesterday).subtract(6, "d").toDate(),
            yesterday,
          ];
          break;
        case "last30":
          this.dateRange1 = [
            moment(yesterday).subtract(29, "d").toDate(),
            yesterday,
          ];
          break;
        case "thisMonth":
          this.dateRange1 = [
            moment(yesterday).startOf("month").toDate(),
            yesterday,
          ];
          break;
        case "lastMonth":
          this.dateRange1 = [
            moment(yesterday).subtract(1, "months").startOf("month"),
            moment(yesterday).subtract(1, "months").endOf("month"),
          ];
          break;
        case "all":
          var start = this.startDate
            ? moment(this.startDate).format("YYYY-MM-DD HH:mm:ss")
            : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
          var endDate = this.endDate
            ? moment(this.endDate).format("YYYY-MM-DD HH:mm:ss")
            : yesterday;
          this.dateRange1 = [start, endDate];
          break;
      }
      if (this.datepicker) {
        this.datepicker.closeMenu();
      }
    },
    prepareLikesData() {
      this.campaignLikes = this.campaignLikes.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return this.campaignLikes;
    },
  },
  mounted() {
    this.getData();
    if (window) {
      this.isMobile = window.matchMedia(
        "only screen and (max-width: 767px)"
      ).matches;
      this.isTablet = window.matchMedia(
        "only screen and (max-width: 991px) and (min-width: 768px)"
      ).matches;
    }
  },
  watch: {
    allLoaded(val) {
      if (val) {
        this.$emit("enablePDFDownload", val);
      }
    },
    dateRange(newVal, oldVal) {
      if (oldVal.length > 0) {
        this.updateDetailChannelData();
      }
      if (newVal && !newVal[1]) {
        this.dateRange[1] = this.dateRange[0];
      }
    },
    dateRange1(newVal, oldVal) {
      if (oldVal.length > 0) {
        this.updateKpiData();
      }
      if (newVal && !newVal[1]) {
        this.dateRange1[1] = this.dateRange1[0];
      }
    },
    campaignId(newVal, oldVal) {
      if (newVal) {
        this.clear();
        this.getData();
      }
    },
  },
};
</script>
